module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.discount.shouldShow && _vm.show) ? _c('div', {
    staticClass: "docer-discount-alert",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideAlert()
      }
    }
  }, [_c('div', {
    staticClass: "discount-image-wrapper",
    class: {
      loaded: _vm.imgLoaded
    }
  }, [_c('img', {
    staticClass: "discount-image",
    attrs: {
      "src": require("./images/discount_alert.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goDiscount()
      },
      "load": function($event) {
        return _vm.imgOnload()
      }
    }
  }), _vm._v(" "), (_vm.imgLoaded) ? _c('span', {
    staticClass: "discount-image-close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideAlert()
      }
    }
  }) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e382af4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/v2/discount/DiscountAlert.vue
// module id = 99
// module chunks = 1